import React from 'react'
import Sidebar from "../components/Sidebar";
import {Link} from "react-router-dom";

function ForgotPassword() {
  return (


      <div className='py-5 my-5'>
        <div className='container'>

          <div className="">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-8 col-xl-6">
                <div className="account-right">
                  <div className="dark-card p-3 p-sm-3 p-md-3 p-lg-5">
                    <div className="dark-card-header">
                      <h2 className="card-title mb-4">Enter New Password</h2>
                    </div>
                    <form>

                      <div className="dark-card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group mb-3">
                              <label className="form-label">
                                Password
                              </label>
                              <input
                                  className="form-control"
                                  type="password"
                                  placeholder="Enter New Password"
                                  required
                              />
                            </div>
                            <div className="form-group mb-5">
                              <label className="form-label">
                                Confirm Password
                              </label>
                              <input
                                  className="form-control"
                                  type="password"
                                  placeholder="Enter Confirm Password"
                                  required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className="col-md-4">
                            <div className="form-group">
                              <button
                                  type="submit"
                                  className="btn btn-primary py-3 px-5 w-100"
                              >
                                Submit
                              </button>
                            </div>
                        </div>
                      </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>
  )
}

export default ForgotPassword